module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ptnum",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rpt1"
    }
  }, [_vm._v("PART 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "pttitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rpt1"
    }
  }, [_vm._v("GETTING TO KNOW YOUR LIVER")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("The liver is one of the most important organs in the body, so keeping it at optimal wellness is fundamental for overall good health. But it’s hard to gauge whether your liver is in good shape or not because you can’t see it and you can’t feel it; it doesn’t offer any obvious feedback. When you eat something good, does your liver feel good? When you drink something bad for your liver, like alcohol, does your liver start to hurt? But if you learn a little bit about the liver, you can understand what puts a strain on it and what helps heal it.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', [_vm._v("In this section, we talk about some of the vital functions of the liver, what the liver does for your body, and the crucial roles it plays in your everyday life. This will help you understand what can go wrong when your liver is sick and injured. Then we detail various liver ailments and disorders—what they are, how they occur, and how you can prevent them.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', [_vm._v("It’s important to understand your liver function in order to see what daily occurrences in your life might be damaging it. So let’s have a look.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d94d33c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Part001.vue
// module id = 75
// module chunks = 0